// extracted by css-extract-rspack-plugin
export default {"root":"root-moYh4W","sm":"sm-o63Htd","lg":"lg-ZZL1sQ"};